export const GET_DATA_ENDPOINT = process.env.PUBLIC_URL + "/data/all_data.json"
// export const CHAT_ENDPOINT=" https://beechf-fantasy.com/api/ask_agent" // Disabled for static deployment